module.exports = __webpack_public_path__ + "img/elem1Image.576bce76.png";